var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon === 'add')?_c('AddFieldIcon',{staticClass:"h-5 w-5 fill-current",class:{
      'cursor-pointer': !_vm.disabled,
      'opacity-50': _vm.disabled
    }}):(_vm.icon === 'remove')?_c('font-awesome-icon',{class:{
      'text-red-500 hover:text-red-700 cursor pointer': !_vm.disabled,
      'text-base-content-100': _vm.disabled
    },attrs:{"icon":"trash"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }